import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/*1.创建组件*/

import Home from '../components/nav/home.vue' //首页

import Evolution from '../components/nav/evolution' //杂志沿革

import Editorial from '../components/nav/editorial' //编委风采

import Oldmeeting from '../components/nav/oldmeeting' //历届会议

import Guide from '../components/nav/guide' //指南与共识

import Sharing from '../components/nav/sharing' //病例分享

import Sharing_details from '../components/secondary/sharing_details.vue' //病例分享详情

import Browse from '../components/nav/browse' //过刊浏览

import Browse_details from '../components/secondary/browse_details.vue' //过刊浏览文章详情页

import Serial_details from '../components/secondary/serial_details.vue' //期刊详情页详情页


import Download_details from '../components/secondary/download_details.vue' //专家箴言详情

import Xinwen from '../components/secondary/xinwen.vue' //专家箴言详情

import Evolution2 from '../components/nav/evolution2' //编辑掠影
import Evolution3 from  '../components/nav/evolution3'
import Expert from '../components/nav/expert' //专家箴言

import Expert_details from '../components/secondary/expert_details.vue' //专家箴言详情

import Poster from '../components/nav/poster' //公益海报

import Poster_details from '../components/secondary/poster_details.vue' //公益海报详情

import Consulting from '../components/nav/consulting' //最新资讯

import Reprint from '../components/nav/reprint' //精华转载

import Surgery from '../components/nav/surgery' //外科天地

import Surgery_details from '../components/secondary/Surgery_details.vue' //外科天地视频详情

import Search from '../components/nav/search.vue' //搜索

import Contact from '../components/nav/contact.vue' //联系我们

import Checkout from '../components/nav/checkout.vue' //后台选择
/*2.配置路由*/
const routes = [
    {
        path: '/home',
        component: Home ,
        // redirect:'/home/home1',
        // children:[
        //     { path: '/home/home1', component: Home1,},
        // ],
    },
    {
        path: '/evolution',
        component: Evolution,
    },
    {
        path: '/editorial',
        component: Editorial,
    },
    {
        path: '/oldmeeting',
        component: Oldmeeting,
    },
    {
        path: '/guide',
        component: Guide,
    },
    {
        path: '/sharing',
        component: Sharing,
    },
    {
        path: '/sharing_details',
        component: Sharing_details,
    },
    {
        path: '/browse',
        component: Browse,
    },
    {
        path: '/browse_details',
        component: Browse_details,
    },
    {
        path:'/serial_details',
        component: Serial_details
    },
    {
        path: '/download_details',
        component: Download_details,
    },
    {
        path: '/xinwen',
        component: Xinwen,
    },
    {
        path: '/evolution2',
        component: Evolution2,
    },
    {
        path: '/evolution3',
        component: Evolution3,
    },
    {
        path: '/consulting',
        component: Consulting,
    },
    {
        path: '/reprint',
        component: Reprint,
    },
    {
        path: '/expert',
        component: Expert,
    },
    {
        path: '/expert_details',
        component: Expert_details,
    },
    {
        path: '/poster',
        component: Poster,
    },
    {
        path: '/poster_details',
        component: Poster_details,
    },
    {
        path: '/surgery',
        component: Surgery,
    },
    {
        path: '/surgery_details',
        component: Surgery_details,
    },
    {
        path: '/search',
        component: Search,
    },
    {
        path: '/contact',
        component: Contact,
    },
    {
        path: '/checkout',
        component: Checkout,
    },
    { path: '*', redirect: '/home' }   /*默认跳转路由*/
]
/*3.实例化VueRouter*/
const router = new VueRouter({
    linkActiveClass: 'active',   // active为路由激活时动态添加的类，类名可以自定义
    routes, // （缩写）相当于 router: routes
    scrollBehavior(to,from,saveTop){ //跳转新页面回到首部
      if(saveTop){
        return saveTop;
      }else{
        return {x:0,y:0}
      }
    },
})

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js